module.exports = __webpack_public_path__ + "img/1f98c.80e43e0.svg";